const STYLE_CHANGE_GATE = 'style-change-gate'

export const BACKDROP = `${STYLE_CHANGE_GATE}-modal-backdrop`
export const MODAL_CONTENT = `${STYLE_CHANGE_GATE}-modal-content`
export const CLOSE_BUTTON = `${STYLE_CHANGE_GATE}-close-button`
export const TITLE_TEXT = `${STYLE_CHANGE_GATE}-title-text`
export const CONTINUE_BUTTON = `${STYLE_CHANGE_GATE}-continue-button`
export const NEVER_MIND_BUTTON = `${STYLE_CHANGE_GATE}-nevermind-button`
